import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import store from "@/store";

export default function familiesListQuery() {
    const toast = useToast()
    const refFamilyListTable = ref(null)
    const perPage = ref(10)
    const totalFamilies = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const tableColumns = [
        { key: 'name', label: i18n.t('Name'), sortable: true },
        { key: 'actions', label: i18n.t('Actions') }
    ]

    const dataMeta = computed(() => {
        const localItemsCount = refFamilyListTable.value ? refFamilyListTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalFamilies.value,
        }
    });

    const refetchData = function() {
        refFamilyListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchFamilies = function(ctx, callback) {
        store.dispatch('families/fetchFamilies', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { families, total } = response.data
            callback(families)
            totalFamilies.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching families list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        fetchFamilies,
        tableColumns,
        perPage,
        currentPage,
        totalFamilies,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refFamilyListTable,
        refetchData,
    }
}
